import React, { useState, useEffect } from "react";
import {
    Card,
    CardFooter,
    CardHeader,
    CardBody,
    Row,
    Col,
    Container,
    Spinner
} from "reactstrap";
import SimpleHeader from "../../components/SimpleHeader/SimpleHeader";
import { NavLink, } from "react-router-dom";
import { useStore } from '../../utilities/appStore'
import { DCGSupportUrl as supportUrl } from '../../constants/urls';

const OverviewPage = () => {
    const [locationUrl, setLocationUrl] = useState(0);
    const [devicesUrl, setDevicesUrl] = useState(0);

    const org = useStore((state) => state.CurrentOrganization);
    const orgId = useStore((state) => state.CurrentOrganizationId);
    const isLoading = useStore((state) => state.isLoading);

    const organizationName = org?.name ?? "";

    useEffect(() => {
        if (orgId !== null
            && orgId !== 0
        ) {
            setLocationUrl(`/Organizations/${orgId}/Locations`);
            setDevicesUrl(`/Organizations/${orgId}/Devices`);
        }

    }, [orgId]);

    return (
        <>
            <SimpleHeader name="Home" parentName="Overview" />
            <Container
                id="org-panel-home"
                className="mt--6 fluid"
                data-testid="overview-container"
            >
                <Row className="justify-content-center">
                    <Col className="card-wrapper rise-on-hover">
                        <NavLink to={!isLoading ? locationUrl : '#'}>
                            <Card className="card-locations">
                                <CardHeader>
                                    <h1 className="m-4 text-center">Locations</h1>
                                </CardHeader>
                                <CardBody className="text-center">
                                    {isLoading &&
                                        <Spinner />
                                    }
                                    {!isLoading &&
                                        <i className="ni ni-building text-blue ni-4x"></i>
                                    }
                                </CardBody>
                                <CardFooter>&nbsp;</CardFooter>
                            </Card>
                        </NavLink>
                    </Col>
                    <Col className="card-wrapper rise-on-hover">
                        <NavLink to={!isLoading ? devicesUrl : '#'}>
                            <Card className="card-devices">
                                <CardHeader>
                                    <h1 className="m-4 text-center">Devices</h1>
                                </CardHeader>
                                <CardBody className="text-center">{isLoading &&
                                    <Spinner />
                                }
                                    {!isLoading &&
                                        <i className="ni ni-tablet-button text-blue ni-4x"></i>
                                    }

                                </CardBody>
                                <CardFooter>&nbsp;</CardFooter>
                            </Card>
                        </NavLink>
                    </Col>
                    <Col className="card-wrapper rise-on-hover">
                        <a href={supportUrl}>
                            <Card className="card-supporthelp">
                                <CardHeader>
                                    <h1 className="m-4 text-center">Support / Help</h1>
                                </CardHeader>
                                <CardBody className="text-center">
                                    <i className="ni ni-single-02 text-blue ni-4x"></i>
                                </CardBody>
                                <CardFooter className="text-right">Learn More &gt;</CardFooter>
                            </Card>
                        </a>
                    </Col>
                </Row>
                <Row className="text-center">
                    <Col>
                        <p className="mx-3 menu-helper-text">Add new locations and manage existing locations.</p>
                    </Col>
                    <Col>
                        <p className="mx-3 menu-helper-text">Add and manage devices. Purchase and activate subscriptions.</p>
                    </Col>
                    <Col>
                        <p className="mx-3 menu-helper-text">Access Knowledge Base to troubleshoot, find video tutorials, and training resources. Can't find what you need? Submit a <a href={supportUrl} style={{ color: 'var(--base-color-teal)' }} >Support Ticket.</a></p>
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    <h2>
                        {organizationName && 
                            <>
                                Organization:&nbsp;
                                <span className="text-green" id="org-name">{organizationName}</span>
                            </>
                        }
                        {isLoading && !organizationName && "Loading organization..."}
                        {!isLoading && !organizationName && "Please select HQ"}
                    </h2>
                </Row>
            </Container>
        </>
    );
};

export default OverviewPage;
